import { styled, Typography, AppBar } from '@mui/material'

export const ErrorSelectorMessage = styled(Typography)(({ theme }) => ({
  position: 'relative',
  top: '-10px',
  marginBottom: '-10px',
  fontSize: '0.75rem',
  color: '#EF2828',
  paddingLeft: theme.spacing(1.5),
}))

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  backgroundColor: '#F0F0F0',
  boxShadow: 'none',
  zIndex: 8,
  padding: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-root': {
    minHeight: 32,
  },
}))
